<template>
  <div>
    <b-modal
      id="modal-event-view"
      @hidden="resetModal"
      @show="openModal"
      size="lg"
      centered
      :title="current_event.name"
    >
      <div>
        <div class="text-xl">Час : {{ current_event.time | moment }}</div>
        <div class="text-xl mt-1">
          Статус : {{ current_event.status | groupStatus }}
        </div>
        <div v-if="current_event.static_group" class="text-xl mt-1">
          Вартість візиту : {{ current_event.static_group.visit_cost }} грн
        </div>
        <div v-if="current_event.visits !== 0" class="mt-2">
          <h5>Візити : {{ current_event.visits }}</h5>
          <h5>
            Гостей : <span class="h5 text-[#186ba8]">{{ guestVisits }}</span>
          </h5>
          <h5>
            Клиентів : <span class="h5 text-[#880d24]">{{ clientVisits }}</span>
          </h5>
          <button
            @click="toggleCollapse"
            class="mt-1 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
          >
            Детальніше
          </button>
          <div
            v-if="isOpen"
            class="mt-2 max-h-[400px] overflow-auto rounded-md bg-gray-50"
          >
            <div
              class="m-2"
              v-for="visit in current_event.visits_obj"
              :key="visit.id"
            >
              <div class="p-2 bg-gray-100 rounded-md border hover:bg-gray-200">
                <h6 v-if="visit.client_id">
                  Клієнт :
                  <a
                    href="#"
                    @click.stop.prevent="clientPage(visit.client.id)"
                    class="text-blue-600 underline"
                  >
                    {{ visit.client.name + " " + visit.client.surname }}
                  </a>
                </h6>
                <!-- <h6 v-if="visit.client_id">
                  Карта : 
                  {{ cardGet(visit.card.product_id).name + ' ' + 
                  (visit.card.total_visits - visit.card.visits) + '/' + 
                  visit.card.total_visits }}
                </h6> -->
                <h6 v-if="!visit.client_id">Гість {{ visit.amount }} грн</h6>
                <hr />
                <h6>{{ visit.time | moment }}</h6>
              </div>
            </div>
          </div>
        </div>
        <b-button
          class="mt-2"
          v-if="
            current_event.group_id &&
            new Date(current_event.time).getDate() ===
              new Date(Date.now()).getDate()
          "
          size="sm"
          variant="success"
          v-on:click="paymentSwitch()"
        >
          Додати гостевий візит
        </b-button>
      </div>
      <div v-if="paymentState">
        <h5 class="mt-2">Кількість :</h5>

        <b-form-input
          id="visitsnum"
          type="number"
          min="1"
          max="100"
          class="mt-2"
          v-model="visitsCount"
        >
        </b-form-input>

        <h5 class="mt-2">Тип оплати</h5>

        <b-form-radio-group
          size="sm"
          buttons
          v-model="payment_type"
          class="mt-1"
          button-variant="outline-success"
          :options="paymentOptions"
        >
        </b-form-radio-group>

        <b-button
          variant="outline-success"
          size="sm"
          style="display: block"
          class="mt-3"
          v-if="payment_type"
          @click="addGuestVisit()"
        >
          Оплатити
        </b-button>
      </div>
    </b-modal>
    <Alert
      :class="this.class"
      v-bind:text="this.AlertText"
      v-bind:activErr="this.activErr"
    ></Alert>
  </div>
</template>

<script>
import moment from "moment";
import { mapActions, mapState } from "vuex";
import axios from "axios";
import Alert from "@/components/Toasts/Alert";

export default {
  name: "EventDetails",
  components: {
    Alert,
  },
  data: function () {
    return {
      collapseOpened: false,
      activErr: false,
      AlertText: "",
      visitsCount: 1,
      class: "",
      detailsState: true,
      paymentState: false,
      payment_type: null,
      paymentOptions: [
        { text: "Готівка", value: "1" },
        { text: "Картка", value: "2" },
      ],
      isOpen: false,
    };
  },
  computed: {
    ...mapState(["current_event", "schedule", "user", "cards"]),
    guestVisits: function () {
      let visits = this.current_event.visits_obj.filter((visit) => {
        return visit.client_id === null;
      });
      return visits.length;
    },
    clientVisits: function () {
      let visits = this.current_event.visits_obj.filter((visit) => {
        return visit.client_id !== null;
      });
      return visits.length;
    },
  },
  methods: {
    ...mapActions(["logOutUser", "getClient", "setCurrentEvent"]),
    openModal() {
      this.$root.$emit("bv::hide::modal", "modal-event-view");
    },
    toggleCollapse() {
      this.isOpen = !this.isOpen;
    },
    isCollapsed(id) {
      return this.openVisit === id;
    },
    resetModal() {
      this.payment_type = null;
      this.detailsState = true;
      this.paymentState = false;
      this.$root.$emit("bv::hide::modal", "modal-event-view");
      this.setCurrentEvent({});
    },
    showModalCreate(text, color) {
      this.activErr = true;
      this.class = color;
      this.AlertText = text;
      setTimeout(() => {
        this.activErr = false;
      }, 4000);
    },
    clientPage(clientId) {
      this.getClient(clientId);
      this.$router.push({ name: "Clients", params: { id: clientId } });
    },
    openCollapse() {
      this.$root.$emit("bv::toggle::collapse", "collapse-visits");
      this.collapseOpened = true;
    },
    paymentSwitch() {
      this.paymentState = true;
      this.detailsState = false;
    },
    switchBack() {
      this.paymentState = false;
      this.detailsState = true;
      this.payment_type = null;
      this.visitsCount = 1;
    },
    cardGet(id) {
      let x = this.cards.plans.filter((card) => {
        return card.id === id;
      });
      return x[0];
    },
    async addGuestVisit() {
      let payload = {
        admin_id: this.user.id,
        amount: this.current_event.static_group.visit_cost,
        payment_type: this.payment_type,
        group_id: this.current_event.id,
        visit_count: this.visitsCount,
      };
      let config = {
        headers: {
          Authorization: `Bearer ${this.$cookie.get("access_token")}`,
        },
      };
      await axios
        .post(
          `${process.env.VUE_APP_API}/visits/register/guest`,
          payload,
          config,
        )
        .then(() => {
          if (this.collapseOpened) {
            this.$root.$emit("bv::toggle::collapse", "collapse-visits");
            this.collapseOpened = false;
          }
          this.showModalCreate("Гостевий візит додано!", "green");
          this.$emit("refresh");
          this.switchBack();
        })
        .catch((error) => {
          if (error.response.status === 400) {
            this.showModalCreate("Це тренування вже закінчено :(", "red");
          } else if (error.response.status === 401) {
            this.logOutUser();
          }
        });
    },
  },
  filters: {
    moment: function (date) {
      return moment(date).locale("uk").format("DD MMMM YYYY HH:mm");
    },
    groupStatus: function (status) {
      if (status === "Planned") {
        return "Запланована";
      } else if (status === "In progress") {
        return "В процесі";
      } else if (status === "Finished") {
        return "Закінчена";
      } else {
        return status;
      }
    },
  },
};
</script>

<style scoped></style>
